module.exports = __webpack_public_path__ + "media/images/sp/page_common/logo/logo_footer_selady-8a29bf531a25e3eceedc525067ee844c.svg";